'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { SMS_MFA } from '../challenges';
import { LoginCard } from '../loginCard';
import { VerificationCodeField } from '../verificationCodeField';
export const MfaStep = t0 => {
  const $ = _c(20);
  const {
    challengeName,
    challengeParameters,
    error,
    submitting,
    onSubmit
  } = t0;
  const [code, setCode] = useState("");
  const destination = challengeParameters?.CODE_DELIVERY_DESTINATION;
  const description = challengeName === SMS_MFA ? `Enter the verification code we sent${destination ? ` to ${destination}` : ""}:` : "Enter the verification code from your authenticator app:";
  let t1;
  if ($[0] !== description) {
    t1 = <Typography variant="subtitle1" className="text-center">{description}</Typography>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== code || $[3] !== onSubmit) {
    t2 = event => {
      event.preventDefault();
      if (code) {
        onSubmit(code);
      }
    };
    $[2] = code;
    $[3] = onSubmit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      gap: "40px"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== code) {
    t4 = <VerificationCodeField id="login-v2-mfa-code" value={code} onChange={setCode} />;
    $[6] = code;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !code || submitting;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      height: "48px"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = submitting ? "Verifying\u2026" : "Verify";
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <Button fullWidth={true} type="submit" variant="contained" disabled={t5} data-testid="login-v2-mfa-submit" sx={t6}>{t7}</Button>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t8) {
    t9 = <Stack component="form" onSubmit={t2} sx={t3}>{t4}{t8}</Stack>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== error || $[17] !== t1 || $[18] !== t9) {
    t10 = <LoginCard error={error}>{t1}{t9}</LoginCard>;
    $[16] = error;
    $[17] = t1;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};